import { useEffect } from 'react';
import useFullscreenLoaderStore, {
  FullscreenLoaderStore,
} from 'v2/store/useFullscreenLoaderStore';
import { shallow } from 'zustand/shallow';

const getFullscreenLoaderStoreData = (state: FullscreenLoaderStore) => ({
  setIsLoading: state.setIsLoading,
  setIsInvisible: state.setIsInvisible,
});

const useFullscreenLoader = ({
  isLoading,
  isInvisible,
}: {
  isLoading: boolean;
  isInvisible?: boolean;
}) => {
  const { setIsLoading, setIsInvisible } = useFullscreenLoaderStore(
    getFullscreenLoaderStoreData,
    shallow,
  );

  useEffect(() => {
    if (isLoading && isInvisible) {
      setIsInvisible({ isInvisible });
    } else {
      setIsInvisible({ isInvisible: false });
    }
    setIsLoading({ isLoading });

    return () => {
      setIsLoading({ isLoading: false });
      setIsInvisible({ isInvisible: false });
    };
  }, [isLoading, setIsLoading, isInvisible, setIsInvisible]);
};

export default useFullscreenLoader;
